/* Customized for Donna Karan */
class Header extends HTMLElement {
  constructor() {
    super();
    this.lastScrollY = window.scrollY;
    this.isScrolled = false; // Track current state
    this.scrollHandler = this.debounce(this.onScroll.bind(this), 10); // Debounced scroll handler
  }

  connectedCallback() {
    this.mobile_nav_menu = document.querySelector('.mobile-nav--menu');
    this.y_menu = this.querySelector('.y-menu');
    this.country_selector = this.querySelector('.header--country-selector');

    this.moveYMenu();
    theme.transitions.reload('y-menu');
    if (Shopify.designMode) this.sectionListeners();

    window.addEventListener('scroll', this.scrollHandler);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.scrollHandler);
  }

  onScroll() {
    let window_top = window.scrollY;

    if (window_top > 25 && !this.isScrolled) {
      this.classList.add('scrolled-down');
      this.isScrolled = true;
    } else if (window_top < 15 && this.isScrolled) {
      this.classList.remove('scrolled-down');
      this.isScrolled = false;
    }
  }

  debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  moveYMenu() {
    this.mobile_nav_menu.innerHTML = '';
    if (this.mobile_nav_menu && this.y_menu) {
      this.mobile_nav_menu.appendChild(this.y_menu);
    }
    if (this.mobile_nav_menu && this.country_selector) {
      let clone = this.country_selector.cloneNode(true);
      this.mobile_nav_menu.appendChild(clone);
    }
  }

  sectionListeners() {
    this.on('theme:section:load', () => theme.drawer.loadTriggers());
  }
}

customElements.define('header-root', Header);
